import { render, staticRenderFns } from "./OfferItemStatus.vue?vue&type=template&id=0dc51059"
import script from "./OfferItemStatus.vue?vue&type=script&lang=js"
export * from "./OfferItemStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports